import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs';
import { toast } from 'ngx-sonner';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { selectBranchId } from '../../../../core/store/auth/auth.selectors';
import { SettingsService } from '../../../../core/services/settings.service';
import { PermissionService, MODULE } from '../../../../core/services/permission.service';

/**
 * Settings > Billing — clinic-wide policy for how the doctor's honorary is
 * released when a bill is paid in installments (Register Payment). Stored on
 * branches_tb.honorary_partial_payout, read by apply_bill_settlement().
 */
@Component({
  selector: 'app-billing-tab',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ToggleSwitchModule],
  templateUrl: './billing-tab.html',
})
export class BillingTab implements OnInit {
  private store = inject(Store);
  private settingsService = inject(SettingsService);
  private translate = inject(TranslateService);
  private perm = inject(PermissionService);

  get canEdit(): boolean {
    return this.perm.canEdit(MODULE.CONFIGURACOES);
  }

  branchId: number | null = null;
  loading: boolean = true;
  isSaving: boolean = false;
  honoraryPartialPayout: boolean = false;

  ngOnInit() {
    this.store
      .select(selectBranchId)
      .pipe(
        filter((id) => !!id),
        take(1),
      )
      .subscribe((id) => {
        this.branchId = Number(id);
        this.loadBranchData();
      });
  }

  loadBranchData() {
    if (!this.branchId) {
      this.loading = false;
      return;
    }
    this.settingsService.getBranchData(this.branchId).subscribe({
      next: (data: any) => {
        this.honoraryPartialPayout = !!data?.honorary_partial_payout;
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Error loading branch billing config:', err);
        this.loading = false;
      },
    });
  }

  onPartialPayoutChange(checked: boolean) {
    if (!this.canEdit || !this.branchId) return;

    this.isSaving = true;
    this.settingsService.updateBranchData(this.branchId, { honorary_partial_payout: checked }).subscribe({
      next: () => {
        this.isSaving = false;
        toast.success(this.translate.instant('billing_save_success'));
      },
      error: (err: any) => {
        this.isSaving = false;
        this.honoraryPartialPayout = !checked; // revert the switch on failure
        console.error('Error updating branch billing config:', err);
        toast.error(this.translate.instant('billing_save_error'));
      },
    });
  }
}
